import { Tooltip } from '@material-ui/core';
import React from 'react';

const BrTrimString = (props) => {
  const { text, showToolTip = true, trimAfterLength, toolTopPosition = 'bottom' } = props;
  if (!text) { return <span />; }
  if (text.trim().length <= trimAfterLength) { return <span>{text}</span>; }
  const trimmedText = `${text.slice(0, trimAfterLength)}...`;
  if (showToolTip) {
    return (
      <Tooltip title={text} placement={toolTopPosition} arrow>
        <span>{trimmedText}</span>
      </Tooltip>
    );
  }
  return <span>{trimmedText}</span>;
};
// BrTrimString.TOOL_TIP_POSITION_LEFT_START = "left-start";
// BrTrimString.TOOL_TIP_POSITION_LEFT = "left";
// BrTrimString.TOOL_TIP_POSITION_LEFT_END = "left-end";

// BrTrimString.TOOL_TIP_POSITION_RIGHT_START = "right-start";
// BrTrimString.TOOL_TIP_POSITION_RIGHT = "right";
// BrTrimString.TOOL_TIP_POSITION_RIGHT_END = "right-end";

// BrTrimString.TOOL_TIP_POSITION_TOP_START = "top-start";
// BrTrimString.TOOL_TIP_POSITION_TOP = "top";
// BrTrimString.TOOL_TIP_POSITION_TOP_END = "top-end";

// BrTrimString.TOOL_TIP_POSITION_BOTTOM_START = "bottom-start";
// BrTrimString.TOOL_TIP_POSITION_BOTTOM = "bottom";
// BrTrimString.TOOL_TIP_POSITION_BOTTOM_END = "bottom-end";

export default BrTrimString;
